import React, { useState, useMemo } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import CommonTable from "../../../../common/CommonTable";

const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;

const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 2018 + 1 }, (_, index) => {
  const year = (2018 + index).toString();
  return { name: year, value: year };
}).reverse();

const LightningDeathData = () => {
  const [selectedYears, setSelectedYears] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleDeathSearch = async (e) => {
    e.preventDefault();
    if (!selectedYears.length) {
      setErrorMessage("Please select at least one year.");
      return;
    }
    setErrorMessage("");
    setLoading(true);
    setHasSearched(true);

    try {
      const response = await fetch(`${backendUrl}lightning/filter_lightning_death_records/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ year: selectedYears.map((y) => parseInt(y, 10)) }),
      });

      const data = await response.json();
      if (!response.ok) {
        setErrorMessage(data.error || "Error fetching data");
        setFilterData([]);
        return;
      }
      setFilterData(data);
    } catch (error) {
      setErrorMessage("Error fetching data: " + error.message);
      setFilterData([]);
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(() => [
    { key: "SlNo", label: "S.No" },
    { key: "year", label: "Year", sortable: true },
    { key: "municipality", label: "Municipality", sortable: true },
    { key: "submunicipality", label: "Sub Municipality", sortable: true },
    { key: "suco", label: "Suco", sortable: true },
    { key: "location", label: "Location" },
    {
      key: "datetime",
      label: "Date & Time",
      sortable: true,
      render: (row) => (row.datetime ? new Date(row.datetime).toLocaleString() : "-"),
    },
    { key: "numberofdeaths", label: "Number of Deaths", align: "right" },
    { key: "numberofinjured", label: "Number of Injured", align: "right" },
  ], []);

  return (
    <>
      <div className="formcontainer1">
        <Form onSubmit={handleDeathSearch}>
          <Row className="align-items-center">
            <Col md={6}>
              <Form.Group className="d-flex align-items-center gap-3">
                <Form.Label className="mb-0">Year</Form.Label>
                <MultiSelect
                  value={selectedYears}
                  onChange={(e) => setSelectedYears(e.value)}
                  options={years}
                  optionLabel="name"
                  display="chip"
                  placeholder="Select Year(s)"
                  className="w-full md:w-20rem"
                  style={{ width: "400px", fontSize: "13px" }}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? "Searching..." : "Search"}
              </Button>
            </Col>
          </Row>
        </Form>
        {errorMessage && (
          <div style={{ marginTop: "10px", color: "red" }}>{errorMessage}</div>
        )}
      </div>

      {hasSearched && (
        <div className="formcontainer1 mt-4">
          <CommonTable
            tableData={filterData}
            columns={columns}
            searchableKeys={["municipality", "submunicipality", "suco", "location"]}
            tableName="Lightning_Death_Data"
            emptyMessage="No lightning death records found."
          />
        </div>
      )}
    </>
  );
};

export default LightningDeathData;
